<app-moniepoint-dialog [dialogType]="alertType">
	<div>
		<div [ngSwitch]="designType">
			<div *ngSwitchCase="MONIEPOINT_DESIGN_TYPE.MONIEPOINT_V2">
				<ng-container [ngSwitch]="alertType">
					<ng-container *ngSwitchCase="'success'">
						<div class="text-center">
							<div class="m-b-20 hidden-xs flex justify-center">
								<svg fill="none" height="68" viewBox="0 0 68 68" width="68"
									xmlns="http://www.w3.org/2000/svg">
									<circle cx="34" cy="34" fill="#1EB12D" fill-opacity="0.1" r="34" />
									<circle cx="32.875" cy="32.875" fill="white" r="16.875" />
									<path
										d="M34 56.5C21.5792 56.4864 11.5136 46.4208 11.5 34V33.55C11.7473 21.1852 21.9278 11.3379 34.294 11.502C46.6602 11.6661 56.5758 21.78 56.495 34.147C56.4142 46.5141 46.3673 56.4976 34 56.5ZM25.2603 34.6592C24.3829 33.7852 22.9635 33.7865 22.0878 34.6623C21.2109 35.5392 21.2109 36.9609 22.0878 37.8378L27.0714 42.8215C28.4127 44.1627 30.5873 44.1627 31.9286 42.8215L45.9137 28.8363C46.7907 27.9593 46.7932 26.5383 45.9194 25.6582C45.0411 24.7737 43.6114 24.7712 42.73 25.6526L30.0183 38.3643C29.7319 38.6507 29.2677 38.6511 28.9807 38.3653L25.2603 34.6592Z"
										fill="#1EB12D" />
								</svg>
							</div>
							<div class="alert-title m-t-20">{{ (title | translate) || ('Success' | translate) }}</div>
							<div class="alert-text" style="white-space: pre-line">
								{{ (message | translate) || ('moniepoint.action_successful' | translate) }}
							</div>
							<div class="m-t-40">
								<app-custom-submit-button (click)="continue()" [block]="true"
									[name]="callbackName ? (callbackName | translate) : ('moniepoint.continue' | translate)">
								</app-custom-submit-button>
							</div>
						</div>
					</ng-container>
					<ng-container *ngSwitchCase="'confirm'">
						<div class="text-center">
							<div class="m-b-20 hidden-xs">
								<div class="m-b-20 flex justify-center">
									<svg fill="none" height="68" viewBox="0 0 68 68" width="68"
										xmlns="http://www.w3.org/2000/svg">
										<circle cx="34" cy="34" fill="#E94444" fill-opacity="0.1" r="34" />
										<path
											d="M34 56.5C21.5736 56.5 11.5 46.4264 11.5 34C11.5 21.5736 21.5736 11.5 34 11.5C46.4264 11.5 56.5 21.5736 56.5 34C56.4864 46.4208 46.4208 56.4864 34 56.5ZM31.75 40.75V45.25H36.25V40.75H31.75ZM31.75 22.75V36.25H36.25V22.75H31.75Z"
											fill="#E94444" />
									</svg>
								</div>
							</div>

							<div *ngIf="title" class="alert-title m-t-20">{{ (title | translate) }}</div>
							<div class="alert-text">{{ (message | translate) || ('moniepoint.confirm_proceed' |
								translate) }}</div>

							<ng-container *ngTemplateOutlet="messageTemplate"></ng-container>

							<div [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="m-t-20" nz-row>
								<div [nzSpan]="12" class="gutter-row" nz-col>
									<button (click)="close()" class="btn btn-link btn-block">
										{{ cancelName ? (cancelName | translate) : ('moniepoint.cancel' | translate)}}
									</button>
								</div>
								<div [nzSpan]="12" class="gutter-row" nz-col>
									<app-custom-submit-button (submitForm)="confirm()" [block]="true"
										[submitting]="submitting"
										[name]="callbackName ? (callbackName | translate) : ('moniepoint.proceed' | translate)">
									</app-custom-submit-button>
								</div>
							</div>
						</div>
					</ng-container>
					<ng-container *ngSwitchCase="'error'">
						<div class="text-center">
							<div class="m-b-20 hidden-xs flex justify-center">
								<svg fill="none" height="68" viewBox="0 0 68 68" width="68"
									xmlns="http://www.w3.org/2000/svg">
									<circle cx="34" cy="34" fill="#E94444" fill-opacity="0.1" r="34" />
									<path
										d="M34 56.5C21.5736 56.5 11.5 46.4264 11.5 34C11.5 21.5736 21.5736 11.5 34 11.5C46.4264 11.5 56.5 21.5736 56.5 34C56.4864 46.4208 46.4208 56.4864 34 56.5ZM31.75 40.75V45.25H36.25V40.75H31.75ZM31.75 22.75V36.25H36.25V22.75H31.75Z"
										fill="#E94444" />
								</svg>
							</div>
							<div class="alert-title m-t-20">{{ (title | translate) || ('moniepoint.operation_failed' |
								translate) }}</div>
							<div class="alert-text" style="white-space: pre-line">
								{{ (message | translate) || ('moniepoint.operation_failed' | translate) }}
							</div>
							<div class="m-t-40">
								<app-custom-submit-button (click)="continue()" [block]="true"
									[name]="callbackName ? (callbackName | translate) : ('moniepoint.continue' | translate)">
								</app-custom-submit-button>
							</div>
						</div>
					</ng-container>
					<ng-container *ngSwitchCase="'info'">
						<div class="text-center">
							<div class="m-b-20 flex justify-center hidden-xs">
								<svg fill="none" height="70" viewBox="0 0 73 74" xmlns="http://www.w3.org/2000/svg">
									<circle cx="36.5" cy="37" fill="#0357EE" fill-opacity="0.1" r="36.5" />
									<path
										d="M37 59.5C24.5736 59.5 14.5 49.4264 14.5 37C14.5 24.5736 24.5736 14.5 37 14.5C49.4264 14.5 59.5 24.5736 59.5 37C59.4864 49.4208 49.4208 59.4864 37 59.5ZM34.75 43.75V48.25H39.25V43.75H34.75ZM34.75 25.75V39.25H39.25V25.75H34.75Z"
										fill="#0361F0" />
								</svg>
							</div>
							<div class="alert-title m-t-20">{{ (title | translate) || ('moniepoint.operation_failed' |
								translate) }}</div>
							<div class="alert-text">{{ (message | translate) || ('moniepoint.operation_failed' |
								translate) }}</div>
							<nz-divider></nz-divider>
							<div [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="m-t-20" nz-row>
								<div [nzSpan]="showInfoModalAcceptButton ? 12 : 24" class="gutter-row" nz-col>
									<button (click)="cancel()" class="btn btn-link btn-block">
										{{ cancelName ? (cancelName | translate) : ('moniepoint.cancel' | translate)}}</button>
								</div>
								<div *ngIf="showInfoModalAcceptButton" [nzSpan]="12" class="gutter-row" nz-col>
									<app-custom-submit-button (submitForm)="confirm()" [block]="true"
										[submitting]="submitting" [name]="callbackName ? (callbackName | translate) : ('moniepoint.accept' | translate)">
									</app-custom-submit-button>
								</div>
							</div>
						</div>
					</ng-container>
					<ng-container *ngSwitchCase="'warning'">
						<div class="text-center">
							<div class="m-b-20 flex justify-center hidden-xs">
								<svg fill="none" height="68" viewBox="0 0 68 68" width="68"
									xmlns="http://www.w3.org/2000/svg">
									<circle cx="34" cy="34" fill="#E94444" fill-opacity="0.1" r="34" />
									<path
										d="M34 56.5C21.5736 56.5 11.5 46.4264 11.5 34C11.5 21.5736 21.5736 11.5 34 11.5C46.4264 11.5 56.5 21.5736 56.5 34C56.4864 46.4208 46.4208 56.4864 34 56.5ZM31.75 40.75V45.25H36.25V40.75H31.75ZM31.75 22.75V36.25H36.25V22.75H31.75Z"
										fill="#E94444" />
								</svg>
							</div>
							<div class="alert-title m-t-20">{{ (title | translate) || ('moniepoint.operation_failed' |
								translate) }}</div>
							<div class="alert-text">{{ (message | translate) || ('moniepoint.operation_failed' |
								translate) }}</div>
							<nz-divider></nz-divider>
							<div [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="m-t-20" nz-row>
								<div [nzSpan]="12" class="gutter-row" nz-col>
									<button (click)="modal.destroy()" class="btn btn-link btn-block">{{ cancelText |
										translate }}</button>
								</div>
								<div [nzSpan]="12" class="gutter-row" nz-col>
									<app-custom-submit-button (submitForm)="confirm()" [block]="true"
										[submitting]="submitting" name="{{ declineText | translate }}" type="decline">
									</app-custom-submit-button>
								</div>
							</div>
						</div>
					</ng-container>
					<ng-container *ngSwitchCase="'delete'">
						<div class="text-center">
							<div class="m-b-20 flex justify-center hidden-xs">
								<svg fill="none" height="68" viewBox="0 0 68 68" width="68"
									xmlns="http://www.w3.org/2000/svg">
									<circle cx="34" cy="34" fill="#E94444" fill-opacity="0.1" r="34" />
									<path
										d="M34 56.5C21.5736 56.5 11.5 46.4264 11.5 34C11.5 21.5736 21.5736 11.5 34 11.5C46.4264 11.5 56.5 21.5736 56.5 34C56.4864 46.4208 46.4208 56.4864 34 56.5ZM31.75 40.75V45.25H36.25V40.75H31.75ZM31.75 22.75V36.25H36.25V22.75H31.75Z"
										fill="#E94444" />
								</svg>
							</div>
							<div class="alert-title m-t-20">{{ (title | translate) || ('moniepoint.operation_failed' |
								translate) }}</div>
							<div class="alert-text">{{ (message | translate) || ('moniepoint.operation_failed' |
								translate) }}</div>
							<nz-divider></nz-divider>
							<div [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="m-t-20" nz-row>
								<div [nzSpan]="12" class="gutter-row" nz-col>
									<button (click)="modal.destroy()" class="btn btn-link btn-block">{{ cancelText |
										translate }}</button>
								</div>
								<div [nzSpan]="12" class="gutter-row" nz-col>
									<app-custom-submit-button (submitForm)="confirm()" [block]="true" [type]="isDecline ? 'decline' : 'primary' "
										[submitting]="submitting" [name]="callbackName ? (callbackName | translate) : ('Delete' | translate)">
									</app-custom-submit-button>
								</div>
							</div>
						</div>
					</ng-container>
					<ng-container *ngSwitchCase="'new_confirm'">
						<div class="text-center">
							<div class="m-b-10 flex justify-center hidden-xs">
								<svg fill="none" height="68" viewBox="0 0 68 68" width="68"
									xmlns="http://www.w3.org/2000/svg">
									<circle cx="34" cy="34" fill="#0361F0" fill-opacity="0.1" r="34" />
									<path
										d="M34 56.5C21.5736 56.5 11.5 46.4264 11.5 34C11.5 21.5736 21.5736 11.5 34 11.5C46.4264 11.5 56.5 21.5736 56.5 34C56.4864 46.4208 46.4208 56.4864 34 56.5ZM31.75 40.75V45.25H36.25V40.75H31.75ZM31.75 22.75V36.25H36.25V22.75H31.75Z"
										fill="#0361F0" />
								</svg>
							</div>
							<div class="alert-title">{{ title | translate }}</div>
							<div class="alert-text">{{ message | translate }}</div>
							<div [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="m-t-20" nz-row>
								<div [nzSpan]="12" class="gutter-row" nz-col>
									<button (click)="close()" class="btn btn-link btn-block">
										{{ cancelName ? (cancelName | translate) : ('moniepoint.decline' | translate)}}
									</button>
								</div>
								<div [nzSpan]="12" class="gutter-row" nz-col>
									<app-custom-submit-button (submitForm)="confirm()" [block]="true"
										[submitting]="submitting"
										[name]="callbackName ? (callbackName | translate) : ('moniepoint.accept' | translate)">
									</app-custom-submit-button>
								</div>
							</div>
						</div>
					</ng-container>
					<div *ngSwitchDefault>''</div>
				</ng-container>
			</div>
			<div *ngSwitchCase="MONIEPOINT_DESIGN_TYPE.KAMONA">
				<ng-container *ngIf="!ref; else refTemplate">
					<ng-container>
						<div class="text-center">
							<div class="hidden-xs flex justify-center">
								<ng-container *ngTemplateOutlet="alertIcon"></ng-container>
							</div>
							<div class="alert-body-session">
								<div class="kamona-alert-title">
									{{ (title | translate) || ('moniepoint.operation_failed' | translate) }}
								</div>
								<div class="kamona-alert-message">
									{{ (message | translate) || ('moniepoint.operation_failed' | translate) }}
								</div>
							</div>
							<div [hidden]="!expiryTime">
								<div>
									<app-kamona-otp-count-down [dayId]="'otp_days'" [expiryTime]="expiryTime"
										[hourId]="'otp_hours'" [minuteId]="'otp_minutes'" [secondId]="'otp_seconds'">
									</app-kamona-otp-count-down>
								</div>
							</div>
							<div class="kamona-alert-divider"></div>
							<div class="alert-btn-session">
								<div>
									<div *ngIf="expiryTime; else alertButtonSession">
										<ng-container *ngTemplateOutlet="cancelAndSubmit"></ng-container>
									</div>
									<ng-template #alertButtonSession>
										<div *ngIf="!cancelName; else cancelAndSubmit">
											<ng-container *ngTemplateOutlet="alertButton"></ng-container>
										</div>
									</ng-template>
								</div>
								<ng-template #cancelAndSubmit>
									<div [nzGutter]="16" nz-row nzAlign="middle">
										<div nz-col nzSpan="12">
											<div (click)="cancel()" class="alert-cancel-btn">
												{{ cancelName }}
											</div>
										</div>
										<div nz-col nzSpan="12">
											<ng-container *ngTemplateOutlet="alertButton"></ng-container>
										</div>
									</div>
								</ng-template>
							</div>
						</div>
					</ng-container>
				</ng-container>
				<ng-template #refTemplate>
					<ng-container [ngComponentOutlet]="ref"></ng-container>
				</ng-template>
			</div>
		</div>
		<ng-template #alertButton>
			<div class="kamona-submit-btn">
				<app-custom-submit-button (click)="continue()" [block]="true"
					[name]="callbackName ? (callbackName | translate) : ('moniepoint.continue' | translate)">
				</app-custom-submit-button>
			</div>
		</ng-template>
		<ng-template #alertIcon>
			<ng-container [ngSwitch]="alertType">
				<ng-container *ngSwitchCase="'error'">
					<ng-container *ngTemplateOutlet="errorIcon"></ng-container>
				</ng-container>
				<ng-container *ngSwitchCase="'confirm'">
					<ng-container *ngTemplateOutlet="confirmIcon"></ng-container>
				</ng-container>
				<ng-container *ngSwitchCase="'info'">
					<ng-container *ngTemplateOutlet="infoIcon"></ng-container>
				</ng-container>
				<ng-container *ngSwitchCase="'warning'">
					<ng-container *ngTemplateOutlet="warningIcon"></ng-container>
				</ng-container>
				<ng-container *ngSwitchCase="'success'">
					<ng-container *ngTemplateOutlet="successIcon"></ng-container>
				</ng-container>
				<ng-container *ngSwitchCase="'new_confirm'">
					<ng-container *ngTemplateOutlet="newConfirmIcon"></ng-container>
				</ng-container>
				<ng-container *ngSwitchCase="'delete'">
					<ng-container *ngTemplateOutlet="deleteIcon"></ng-container>
				</ng-container>
			</ng-container>
		</ng-template>
		<ng-template #errorIcon>
			<svg fill="none" height="68" viewBox="0 0 68 68" width="68" xmlns="http://www.w3.org/2000/svg">
				<circle cx="34" cy="34" fill="#E94444" fill-opacity="0.1" r="34" />
				<path
					d="M34 56.5C21.5736 56.5 11.5 46.4264 11.5 34C11.5 21.5736 21.5736 11.5 34 11.5C46.4264 11.5 56.5 21.5736 56.5 34C56.4864 46.4208 46.4208 56.4864 34 56.5ZM31.75 40.75V45.25H36.25V40.75H31.75ZM31.75 22.75V36.25H36.25V22.75H31.75Z"
					fill="#E94444" />
			</svg>
		</ng-template>
		<ng-template #deleteIcon>
			<svg fill="none" height="68" viewBox="0 0 68 68" width="68" xmlns="http://www.w3.org/2000/svg">
				<circle cx="34" cy="34" fill="#E94444" fill-opacity="0.1" r="34" />
				<path
					d="M34 56.5C21.5736 56.5 11.5 46.4264 11.5 34C11.5 21.5736 21.5736 11.5 34 11.5C46.4264 11.5 56.5 21.5736 56.5 34C56.4864 46.4208 46.4208 56.4864 34 56.5ZM31.75 40.75V45.25H36.25V40.75H31.75ZM31.75 22.75V36.25H36.25V22.75H31.75Z"
					fill="#E94444" />
			</svg>
		</ng-template>
		<ng-template #successIcon>
			<svg fill="none" height="68" viewBox="0 0 68 68" width="68" xmlns="http://www.w3.org/2000/svg">
				<circle cx="34" cy="34" fill="#1EB12D" fill-opacity="0.1" r="34" />
				<circle cx="32.875" cy="32.875" fill="white" r="16.875" />
				<path
					d="M34 56.5C21.5792 56.4864 11.5136 46.4208 11.5 34V33.55C11.7473 21.1852 21.9278 11.3379 34.294 11.502C46.6602 11.6661 56.5758 21.78 56.495 34.147C56.4142 46.5141 46.3673 56.4976 34 56.5ZM25.2603 34.6592C24.3829 33.7852 22.9635 33.7865 22.0878 34.6623C21.2109 35.5392 21.2109 36.9609 22.0878 37.8378L27.0714 42.8215C28.4127 44.1627 30.5873 44.1627 31.9286 42.8215L45.9137 28.8363C46.7907 27.9593 46.7932 26.5383 45.9194 25.6582C45.0411 24.7737 43.6114 24.7712 42.73 25.6526L30.0183 38.3643C29.7319 38.6507 29.2677 38.6511 28.9807 38.3653L25.2603 34.6592Z"
					fill="#1EB12D" />
			</svg>
		</ng-template>
		<ng-template #infoIcon>
			<svg fill="none" height="70" viewBox="0 0 73 74" xmlns="http://www.w3.org/2000/svg">
				<circle cx="36.5" cy="37" fill="#0357EE" fill-opacity="0.1" r="36.5" />
				<path
					d="M37 59.5C24.5736 59.5 14.5 49.4264 14.5 37C14.5 24.5736 24.5736 14.5 37 14.5C49.4264 14.5 59.5 24.5736 59.5 37C59.4864 49.4208 49.4208 59.4864 37 59.5ZM34.75 43.75V48.25H39.25V43.75H34.75ZM34.75 25.75V39.25H39.25V25.75H34.75Z"
					fill="#0361F0" />
			</svg>
		</ng-template>
		<ng-template #warningIcon>
			<svg fill="none" height="68" viewBox="0 0 68 68" width="68" xmlns="http://www.w3.org/2000/svg">
				<circle cx="34" cy="34" fill="#F08922" fill-opacity="0.1" r="34" />
				<path
					d="M34 56.5C21.5736 56.5 11.5 46.4264 11.5 34C11.5 21.5736 21.5736 11.5 34 11.5C46.4264 11.5 56.5 21.5736 56.5 34C56.4864 46.4208 46.4208 56.4864 34 56.5ZM31.75 40.75V45.25H36.25V40.75H31.75ZM31.75 22.75V36.25H36.25V22.75H31.75Z"
					fill="#F08922" />
			</svg>
		</ng-template>
		<ng-template #newConfirmIcon>
			<svg fill="none" height="68" viewBox="0 0 68 68" width="68" xmlns="http://www.w3.org/2000/svg">
				<circle cx="34" cy="34" fill="#0361F0" fill-opacity="0.1" r="34" />
				<path
					d="M34 56.5C21.5736 56.5 11.5 46.4264 11.5 34C11.5 21.5736 21.5736 11.5 34 11.5C46.4264 11.5 56.5 21.5736 56.5 34C56.4864 46.4208 46.4208 56.4864 34 56.5ZM31.75 40.75V45.25H36.25V40.75H31.75ZM31.75 22.75V36.25H36.25V22.75H31.75Z"
					fill="#0361F0" />
			</svg>
		</ng-template>
		<ng-template #confirmIcon>
			<svg fill="none" height="68" viewBox="0 0 68 68" width="68" xmlns="http://www.w3.org/2000/svg">
				<circle cx="34" cy="34" fill="#0361F0" fill-opacity="0.1" r="34" />
				<path
					d="M34 56.5C21.5736 56.5 11.5 46.4264 11.5 34C11.5 21.5736 21.5736 11.5 34 11.5C46.4264 11.5 56.5 21.5736 56.5 34C56.4864 46.4208 46.4208 56.4864 34 56.5ZM31.75 40.75V45.25H36.25V40.75H31.75ZM31.75 22.75V36.25H36.25V22.75H31.75Z"
					fill="#0361F0" />
			</svg>
		</ng-template>
	</div>
</app-moniepoint-dialog>
